<template>
  <div>
    <wx-punch v-if="activeIndex === 0" :work-plan-config="workPlanConfig"></wx-punch>
    <wx-punch-in-record v-else></wx-punch-in-record>
    <van-tabbar v-model="activeIndex">
      <van-tabbar-item>
        打卡
        <template #icon>
          <i class="el-icon-odometer"></i>
        </template>
      </van-tabbar-item>
      <van-tabbar-item>
        记录
        <template #icon>
          <i class="el-icon-files"></i>
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
  import { getData } from '@/utils/request'
  import { Tabbar, TabbarItem } from 'vant'
  import WxPunch from '@/views/wx/punch/WxPunch'
  import WxPunchInRecord from '@/views/wx/punch/WxPunchInRecord'

  export default {
    name: 'WxPunchMain',
    props: {
      active: {
        type: Number,
        default: 0
      }
    },
    components: {
      WxPunchInRecord,
      WxPunch,
      [Tabbar.name]: Tabbar,
      [TabbarItem.name]: TabbarItem
    },
    data () {
      return {
        activeIndex: 0,
        workPlanConfig: {
          beginTime: null,
          endTime: null
        }
      }
    },
    created () {
      getData('workPlanConfig').then(response => {
        this.workPlanConfig.beginTime = response.data.beginTime
        this.workPlanConfig.endTime = response.data.endTime
      })
    },
    watch: {
      active: {
        handler (value) {
          this.activeIndex = value
        },
        immediate: true
      }
    }
  }
</script>
